<template>
  <v-container v-if="loading">
    <div class="text-xs-center">
        <v-progress-circular
          indeterminate
          :size="150"
          :width="8">
        </v-progress-circular>
      </div>
  </v-container>
  <v-container v-else fluid class="recall-container">

    <v-card class="recall-card recall-card-single" hover data-aos="zoom-in" data-aos-easing="ease">
      <v-layout row wrap>
        <v-flex xs12 md5>
          <ProductZoomer
            :base-images="images"
            :base-zoomer-options="zoomerOptions"
            id="product-zoomer-container"
            class="product-images"
          />
        </v-flex>
        <v-flex xs12 md7 text-xs-left>
          <v-card-title primary-title class="recall-content">
            <v-btn flat color="green" @click="$router.go(-1)" class="recall-window-close" alt="close"><v-icon>close</v-icon></v-btn>
            <div class="recall-details">
              <div class="recall-title headline">{{ singleRecall.Title }}</div>
              <div class="recall-description">{{ singleRecall.Description }}</div>
              <div class="recall-date">
                  {{ formatDate(singleRecall.RecallDate) }}
              </div>

              <v-divider light></v-divider>

              <v-layout row wrap>
                <v-flex xs12 sm2>
                  <div class="label">Products:</div>
                </v-flex>
                <v-flex xs12 sm10>
                  <div v-for="(item, idx) in singleRecall.Products" :key="idx">
                    <div>{{ item.Name }}</div>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm2>
                  <div class="label">Retailer:</div>
                </v-flex>
                <v-flex xs12 sm10>
                  <div v-for="(item, idx) in singleRecall.Retailers" :key="idx">
                    {{ item.Name }}
                  </div>
                </v-flex>
              </v-layout>

              <v-divider light></v-divider>

              <v-layout row wrap>
                <v-flex xs12 sm2>
                  <div class="label">Hazards:</div>
                </v-flex>
                <v-flex xs12 sm10>
                  <div v-for="(item, idx) in singleRecall.Hazards" :key="idx">
                    {{ item.Name }}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm2>
                  <div class="label">Injuries:</div>
                </v-flex>
                <v-flex xs12 sm10>
                  <div v-for="(item, idx) in singleRecall.Injuries" :key="idx">
                    {{ item.Name }}
                  </div>
                </v-flex>
              </v-layout>

              <v-divider light></v-divider>

              <v-layout row wrap>
                <v-flex xs12 sm2>
                  <div class="label">Remedies:</div>
                </v-flex>
                <v-flex xs12 sm10>
                  <div v-for="(item, idx) in singleRecall.Remedies" :key="idx">
                    {{ item.Name }}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm2>
                  <div class="label">Options:</div>
                </v-flex>
                <v-flex xs12 sm10 class="remedy-options">
                    <span v-for="(item, idx) in singleRecall.RemedyOptions" :key="idx">
                      <span v-if="idx != 0">, </span><span>{{ item.Option }}</span>
                    </span>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 sm2>
                  <div class="label">Contact:</div>
                </v-flex>
                <v-flex xs12 sm10>
                  <div>{{ singleRecall.ConsumerContact }}</div>
                </v-flex>
              </v-layout>

            </div>
          </v-card-title>
        </v-flex>
      </v-layout>
      <v-divider light></v-divider>
      <v-card-actions class="pa-3 recall-details-footer">

        <div class="last-update-xs" v-show="$vuetify.breakpoint.xs">Last Update: {{ formatDate(singleRecall.LastPublishDate) }}</div>

        <v-btn flat color="green" @click="$router.go(-1)"><v-icon class="pr-1">mdi-arrow-left</v-icon>back</v-btn>
        <v-spacer></v-spacer>
          <div class="hidden-xs-only">Last Update: {{ formatDate(singleRecall.LastPublishDate) }}</div>
        <v-spacer></v-spacer>
        <social v-bind:id=id v-bind:title=singleRecall.Title></social>
      </v-card-actions>

    </v-card>
  </v-container>
</template>

<script>
import Vue from 'vue'
import * as moment from 'moment/moment'
import recallApi from '@/services/RecallApi'

export default {
  props: ['id'],

  data () {
    return {
      singleRecall: '',
      dialog: false,
      loading: true,

      images: {
        normal_size: [
          {
            id: 0,
            url: ''
          }
        ]
      },
      zoomerOptions: {
        zoomFactor: 4,
        pane: 'container',
        hoverDelay: 300,
        namespace: 'container-zoomer',
        move_by_click: true,
        scroll_items: 4,
        choosed_thumb_border_color: '#5C8DFD'
      }
    }
  },
  methods: {
    fetchRecallData () {
      recallApi.fetchSingleRecall(this.id)
        .then(response => {
          this.singleRecall = response

          var i = 0
          var items = response.Images

          for (i = 0; i < items.length; i++) {
            Vue.set(this.images.normal_size, i, {
              id: i + 1,
              url: items[i].URL
            })
          }

          // console.log(response)
          this.loading = false
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })
    },
    formatDate (date) {
      return moment(date).format('MMMM DD, YYYY')
    },
    back () {
      this.$router.push('/')
    }
  },
  mounted () {
    this.fetchRecallData()
  }
}

</script>

<style lang="scss" scoped>
  $base-font-color: #242123;
  $base-font-color-lighter: rgba(36, 33, 35, .8);

  .recall-container {
    padding: 2rem;

    .recall-card-single {

      .recall-window-close {
        position: absolute;
        top: -16px;
        right: -12px;
        background-color: #fff;
        border-radius: 16px;
        padding: 0;
        margin: 0;
        width: 36px;
        min-width: 36px;
        height: 36px;

        &:hover {
          position: absolute;
        }
      }

      .product-images {
        padding: .75rem;
      }

      .recall-content {
        padding-top: 0;

        .recall-description {
          padding-top: 8px;
          padding-bottom: 16px;
        }

        .recall-date {
          //@debugcolor: $base-font-color;
          font-weight: 700;
        }

        .recall-details {
          padding: 12px 24px;
        }

        .v-divider {
          margin: 4px 0;
        }

        .label {
          font-weight: 700;
          color: $base-font-color-lighter;
        }

        .remedy-options {
          padding: 2px 0;
        }

      }

      .recall-details-footer {
        flex-wrap: wrap;
      }

      .last-update-xs {
        flex: 1 100%;
      }
    }

  }
</style>

<style>
  #container-zoomer-pane-container {
      display: none !important;
  }
  .preview-box > img {
    max-height: 500px;
  }
  .control-box {
    padding: 0 4px;
  }
  .thumb-list > img {
    min-height: 140px;
    max-height: 140px;
    object-fit: cover;
  }
</style>
